import { Palette } from '@/themes/themeOverrides/Palette';

export const importInputBaseStyles = {
    '& .RaFileInput-dropZone': {
        border: `2px dashed ${Palette.gray.gray200}`,
        borderRadius: '16px',
        backgroundColor: Palette.gray.gray50,
        '& .import-info': {
            margin: '58px 30px 58px 30px',
            '& .MuiTypography-root': {
                display: 'block',
                fontSize: '16px',
                lineHeight: '22px',
                fontWeight: '400',
                maxWidth: '332px',
                margin: '0 auto 4px',
            },
            '& .btn-import': {
                margin: '25px auto 0',
                display: 'flex',
                width: 'max-content',
                backgroundColor: Palette.yellow.yellow400,
                padding: '12px 20px 12px 16px',
                lineHeight: '20px',
                fontSize: '14px',
                fontWeight: '500',
                textTransform: 'none',
                borderRadius: '12px',
                '& svg': {
                    width: '20px',
                    height: '20px',
                    marginRight: '6px',
                },
                '&.loading': {
                    backgroundColor: Palette.gray.gray100,
                    '& svg': {
                        animation: 'spin 1s linear infinite',
                        '@keyframes spin': {
                            '0%': { transform: 'rotate(0deg)' },
                            '100%': { transform: 'rotate(360deg)' },
                        },
                    },
                },
                '&::before': {
                    display: 'none',
                },
            },
        },
    },
    '& .previews': {
        '& .RaFileInputPreview-removeButton': {
            display: 'none',
        },
        '& .MuiLink-root': {
            fontFamily: 'Inter, Arial, sans-serif',
            fontWeight: 600,
            fontSize: '14px',
            pointerEvents: 'none',
            textDecoration: 'none',
            whiteSpace: 'nowrap',
        },
    },
};
